<template>
  <section class="container-fluid">
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Importar calificaciones</strong>
          </CCardHeader>
          <CCardBody>
            <ValidationObserver ref="form" v-slot="{ invalid }">
              <section class="row" v-if="courseOffered.id !== null">
                <div class="col">
                  <p>
                    <b>Curso:</b> {{ courseOffered.course_name }}
                    <b>Paralelo:</b> {{ courseOffered.parallel }} <b>Año:</b>
                    {{ courseOffered.courses_offered_year }} <b>Periodo:</b>
                    {{ courseOffered.period }} <b>Horario:</b> {{ courseOffered | schedule}}
                  </p>
                </div>
              </section>
              <form @submit.prevent="edit" target="_blank">
                <section class="row">
                  <div class="col">
                    <div class="form-group required">
                      <label class="control-label" for="file"
                        >Seleccione el archivo a importar</label
                      >
                      <VueFileAgent
                        ref="vueFileAgent"
                        :theme="'list'"
                        :multiple="false"
                        :deletable="true"
                        :meta="true"
                        :accept="''"
                        :maxSize="'10MB'"
                        :maxFiles="1"
                        :auto="true"
                        :helpText="'Seleccione o arrastre el archivo'"
                        :errorText="{
                          type: 'Tipo de archivo invalido.',
                          size: 'Los archivos no deben exceder los 10 MB de tamaño.',
                        }"
                        @select="filesSelected($event)"
                        @beforedelete="onBeforeDelete($event)"
                        @delete="fileDeleted($event)"
                        v-model="fileRecords"
                      ></VueFileAgent>
                    </div>
                  </div>
                </section>
                <router-link
                  :to="{ path: '/cursos-ofertados-profesor' }"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a
                    :href="href"
                    class="card-header-action btn btn-sm btn-danger"
                    @click="navigate"
                  >
                    <CIcon size="sm" name="cil-x-circle" /> Cancelar
                  </a>
                </router-link>
                <button
                  type="submit"
                  class="btn btn-success btn-sm float-right"
                  variant="success"
                  :disabled="invalid || editLoader || fileRecords.length < 1"
                >
                  <span v-if="!editLoader">
                    <CIcon size="sm" name="cil-save" />
                    Importar
                  </span>
                  <span v-if="editLoader">
                    Cargando
                    <CSpinner color="success" size="sm" />
                  </span>
                </button>
              </form>
            </ValidationObserver>
            <div class="mt-4">
              <div v-if="importDataLoaded">
                <hr />
                <h4>Importación de calificaciones</h4>
                <h6><b>Curso:</b> {{ courseOfferedName }}</h6>
                <CDataTable
                  class="table-bordered c-table c-table-main"
                  :hover="true"
                  :striped="true"
                  :bordered="true"
                  :small="true"
                  :items="items"
                  :fields="fields"
                  :sorter="{ external: true, resetable: true }"
                  :columnFilter="{ external: true, lazy: true }"
                  :column-filter-value.sync="columnFilter"
                  :loading="loading"
                >
                  <template #no-items-view>
                    <div class="no-items-view">
                      {{
                        loading
                          ? "Cargando datos..."
                          : "No existen calificaciones importadas"
                      }}
                      <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
                    </div>
                  </template>
                  <!-- filters -->
                  <!-- data -->
                  <template #id="{ index }">
                    <td>{{ (page - 1) * limit + (index + 1) }}</td>
                  </template>
                </CDataTable>
                <div class="mt-2 text-center">
                  <router-link
                    :to="{ path: '/cursos-ofertados-profesor' }"
                    custom
                    v-slot="{ href, navigate }"
                  >
                    <a
                      :href="href"
                      class="btn btn-sm btn-danger"
                      @click="navigate"
                    >
                      <CIcon size="sm" name="cil-x-circle" /> Cerrar
                    </a>
                  </router-link>
                </div>
              </div>
              <div v-else-if="importDataLoader">
                Cargando
                <CSpinner color="danger" size="sm" />
              </div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import { BFormInvalidFeedback, BFormFile, BFormGroup } from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
//services
import CoursesOffered from "@/plugins/services/courses-offered";
import config from "@/plugins/services/config";
import Grades from "@/plugins/services/grades";

export default {
  name: "GradesImport",
  components: { BFormInvalidFeedback, BFormFile, BFormGroup },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
        },
        {
          key: "student_fullname",
          label: "Last Names and Names",
          sorter: false,
          filter: false,
        },
        {
          key: "absence",
          label: "Nro Abs",
          sorter: false,
          filter: false,
        },
        {
          key: "permission",
          label: "Nro Prm",
          sorter: false,
          filter: false,
        },
        {
          key: "attendence",
          label: "Att",
          sorter: false,
          filter: false,
        },
        {
          key: "works",
          label: "Works",
          sorter: false,
          filter: false,
        },
        {
          key: "class_participation",
          label: "CP",
          sorter: false,
          filter: false,
        },
        {
          key: "quizes",
          label: "Qs",
          sorter: false,
          filter: false,
        },
        {
          key: "final_test",
          label: "FT",
          sorter: false,
          filter: false,
        },
        {
          key: "final_grade",
          label: "FG",
          sorter: false,
          filter: false,
        },
        {
          key: "observations",
          label: "Observation",
          sorter: false,
          filter: false,
        },
      ],
      items: [],
      grade: {},
      courseOffered: {
        id: null,
      },
      columnFilter: { column: null, asc: false },
      page: 1,
      limit: 30,
      loading: false,
      courseOfferedName: null,
      editLoader: false,
      importDataLoader: false,
      importDataLoaded: false,
      dataLoader: false,
      fileRecords: [],
      files: [],
      uploadUrl: `${process.env.MIX_APP_API_ENDPOINT}/grades/upload`,
      deleteUrl: `${process.env.MIX_APP_API_ENDPOINT}/grades/delete`,
      uploadHeaders: { "X-CSRF-TOKEN": config.token },
      fileRecordsForUpload: [],
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  created() {},
  mounted() {
    const { id } = this.$route.params;
    this.getOne(id);
  },
  watch: {
    fileRecordsForUpload(fileRecordsForUpload) {
      this.$emit("fileRecordsForUpload", fileRecordsForUpload.length);
    },
  },
  methods: {
    getOne(id) {
      this.dataLoader = true;
      this.uploadUrl = this.uploadUrl + "/" + id;
      CoursesOffered.getOne(id)
        .then((res) => {
          this.courseOffered = res.data;
          this.dataLoader = true;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Curso ofertado no encontrado.");
            this.$router.push("/cursos-ofertados-profesor");
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.$router.push("/cursos-ofertados-profesor");
          }
          this.dataLoader = false;
        });
    },
    edit() {
      this.editLoader = true;
      this.importDataLoader = true;
      this.loading = true;
      const { id } = this.$route.params;
      this.grade.modified_by = this.userAuth.username;
      this.grade.file = this.fileRecords[0].upload.data;
      Grades.import(id, this.grade)
        .then((res) => {
          this.editLoader = false;
          this.importDataLoader = false;
          this.importDataLoaded = true;
          this.loading = false;
          if (res.data.success && res.data.data != false) {
            this.items = res.data.data;
            this.courseOfferedName = this.items[0];
            this.items.shift();
          } else {
            this.items.messageError = res.data.message;
            Utils.setFlash("danger", this.items.messageError);
          }
        })
        .catch((err) => {
          this.editLoader = false;
          if (err.response && err.response.status == 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Error (400).");
            this.$router.push("/cursos-ofertados-profesor");
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error (500).");
            this.$router.push("/cursos-ofertados-profesor");
          }
        });
    },
    uploadFiles: function () {
      this.$refs.vueFileAgent
        .upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload)
        .then((res) => {
          this.files = this.files.concat(res);
          this.$emit("grades", this.files);
        });
      this.fileRecordsForUpload = [];
    },
    deleteUploadedFile: function (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent
        .deleteUpload(this.deleteUrl, this.uploadHeaders, fileRecord)
        .then((res) => {
          if (res.fileRecord) {
            this.files = this.files.filter(function (file) {
              return (
                file.fileRecord.file.name !== res.fileRecord.file.name &&
                file.fileRecord.file.size !== res.fileRecord.file.size
              );
            });
            this.$emit("grades", this.files);
          }
        });
    },
    filesSelected: function (fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      this.fileRecordsForUpload =
        this.fileRecordsForUpload.concat(validFileRecords);
      this.uploadFiles();
    },
    onBeforeDelete: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1);
        var k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
      } else {
        if (confirm("¿Estás seguro de que quieres eliminar el archivo?")) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
        }
      }
    },
    fileDeleted: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      } else {
        this.deleteUploadedFile(fileRecord);
      }
    },
  },
};
</script>
